import React from 'react';
import { getApp } from '../mocks/automationData';
interface AppLogoProps {
  appId: string;
  size?: 'sm' | 'md' | 'lg';
}
const sizeMap = {
  sm: 'w-5 h-5 text-[9px]',
  md: 'w-8 h-8 text-xs',
  lg: 'w-10 h-10 text-sm'
};
export function AppLogo({
  appId,
  size = 'md'
}: AppLogoProps) {
  const app = getApp(appId);
  const color = app?.logoColor || 'bg-gray-500';
  const label = (app?.name || appId).charAt(0).toUpperCase();
  return <div className={`${sizeMap[size]} ${color} rounded-md flex items-center justify-center text-white font-bold flex-shrink-0`} title={app?.name || appId} data-id="element-2830">
      {label}
    </div>;
}